import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Col, FormGroup } from 'react-bootstrap';

import {
  Divider,
  Heading,
  FormBox,
  Footer,
} from '../../StyledComponents/StyledComponents';
import ComponentHelper from '../../../helpers/ComponentHelper';
import styled from 'styled-components';

const Text = styled.p`
    font-size: 16px;
`;

const Link = styled.a`
  color: #F8444F;
  text-decoration: underline;
`;

class General extends Component {
  render() {
    const { content, formValues, form, blankFormUrl } = this.props;

    return (
      <>
        <FormGroup>
          <Col sm={12}>
            <Heading>Agency - General Information</Heading>
          </Col>
        </FormGroup>
        <FormBox>
          <Text>
            If you are applying to work with us as an Insurance Broker, please fill out
            our Online Application Form below. Alternatively, you can download the form and post it to us{' '}
            {blankFormUrl ? (
              <span>
                — click{' '}
                <Link href={blankFormUrl} target={'_blank'}>

                  here
                </Link>
                {' '}to download form.
              </span>
            ) : (
              ''
            )}
          </Text>
          <Divider />

          <ComponentHelper
            contentFields={content.fields}
            formValues={formValues}
            labelSize={3}
            colSize={5}
            form={form}
          />
          <Footer>
            In applying for this agency we must emphasise that both parties will each be
            required to comply with our respective responsibilities in relation to
            financial crime, which includes, but is not limited to Money Laundering, The
            Bribery Act 2000, Financial Sanctions, and the Data Protection Act 1998.
          </Footer>
        </FormBox>
      </>
    );
  }
}

export default connect(() => {
  return {
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  };
})(General);
